module.exports = __webpack_public_path__ + "img/Request Demo Arrow (copy 1).f6df7608.svg";